import React, {useState, useEffect} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams
  } from "react-router-dom";
  
import Menu from '../Menu/Menu';
import AnimatedPage from '../AnimatedPages';
import PageLoader from '../PageLoader';
import AreaLeft from "./AreaLeft";
import AreaRight from './AreaRight';
export default function AreaView(){







    const { areaId } = useParams()

   
    const [data, setData] = useState([]);
const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      fetchData();
    }, []);
  
    const fetchData = async () => {
      try {
        const response = await fetch('https://attractionsbase.com/api/getareaname/?id=' + areaId);
        const jsonData = await response.json();
        setData(jsonData);
        setLoading(false);
        document.title = jsonData[0].name +  " | AttractionsBase"
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(true);
      }
    };


    return (
<>
<AnimatedPage>
{ loading ? <PageLoader isError={error} /> :
<div className="item-view-wrapper">
 <AreaLeft data={data} /> 
 <AreaRight data={data} />
 </div>
    }
    </AnimatedPage>
</>
)

    




}